import { Building2, Users } from 'lucide-react';
import { HubPageLayout, SettingsRowDef } from './HubPageLayout';

export function IomiOrgsUsersHubPage() {
  const rows: SettingsRowDef[] = [
    {
      id: 'organizations',
      label: 'Manage Organizations',
      desc: 'Create and manage client companies and their user allocations.',
      icon: Building2,
      path: '/admin/platform-tools/organizations',
    },
    {
      id: 'users',
      label: 'Manage Users',
      desc: 'Grant or revoke Platform Admin access for any platform user.',
      icon: Users,
      path: '/admin/platform-tools/users',
    },
  ];

  return (
    <HubPageLayout
      title="Organizations & Users"
      subtitle="Manage client companies and platform users."
      rows={rows}
      backPath="/admin/platform-tools"
      backLabel="Platform Admin Tools"
    />
  );
}
